import { getWindowObject } from '../../utils/window';

export const openUrl = (url: string): void => {
  const windowObject = getWindowObject();
  windowObject.open(url, '_self');
};
